import { Instance } from 'mobx-state-tree';
import { ProjectStopRescheduledDtoModelBase } from './ProjectStopRescheduledDtoModel.base';

/* The TypeScript type of an instance of ProjectStopRescheduledDtoModel */
export interface ProjectStopRescheduledDtoModelType extends Instance<typeof ProjectStopRescheduledDtoModel.Type> {}

/* A graphql query fragment builders for ProjectStopRescheduledDtoModel */
export { selectFromProjectStopRescheduledDto, projectStopRescheduledDtoModelPrimitives, ProjectStopRescheduledDtoModelSelector } from './ProjectStopRescheduledDtoModel.base';

/**
 * ProjectStopRescheduledDtoModel
 *
 * Route rescheduled a stop
 */
export const ProjectStopRescheduledDtoModel = ProjectStopRescheduledDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
